import React from 'react';
import './styles/globals.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import GoogleSection from './components/GoogleSection';
import ClutchSection from './components/ClutchSection';
import ThumtackSection from './components/ThumtackSection';
import TrustpilotSection from './components/TrustpilotSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Cursor from './components/Cursor';
import ParticleCanvas from './components/ParticleCanvas';
import Testimonialsection from "./components/Testimonialsection"; 

export default function App() {
  return (
    <>
      {/* <Cursor /> */}
      <ParticleCanvas />
      <Nav />
      <Hero />
      <Marquee />
      <div className="reviews-intro">
        <h2>Real Client Experiences with KodersPedia</h2>
      </div>
      <GoogleSection />
      <ClutchSection />
      <ThumtackSection />
      <TrustpilotSection />
      <Testimonialsection />
      <CTASection />
      <Footer />
    </>
  );
}
